var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-heading",attrs:{"data-active":_vm.isActive},on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"tab-heading__label font-medium"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }